export const REACTION_BADGE_SIZE = 24;
